import React from 'react';
import Footer from './Footer';
import Sponsors from './Sponsors';

const Layout = ({ children }) => {
  return (
    <div className="main-container">
      {children}
      <Sponsors />
      <Footer />
    </div>
  );
};

export default Layout;
